<script setup>

  const props = defineProps( {
    label: { type: String, default: '' },
    justText: { type: Boolean, default: false },
    errors: { type: Array, default: () => [] }
  })
</script>

<template>
    <tr>
      <td v-if="!props.justText && props.label !== ''">
        <span class="ft__cell ft__label">{{ props.label }}</span>
      </td>
      <td v-if="!props.justText">
        <span class="ft__cell ft__input"><slot></slot></span>
      </td>
      <td v-if="props.justText" colspan="2">
        <span class="ft__cell ft__just-text"><slot></slot></span>
      </td>
    </tr>
    <tr 
      v-for="(error, index) in props.errors"
      :key="index"
      >
      <td colspan="2">
        <span class="ft__cell ft__error">{{ error.message }}</span>
      </td>
    </tr>
</template>
